export const applicationData = {
  name: 'Unified Deal Starter',
  solution: 'Retail360'
};
const createEvent = (element, action, tagIndex) => ({
  element,
  action,
  tagIndex,
  application: applicationData
});
export const nativeDealEventValues = {
  buildYourToggle: createEvent('Build Your Offer Toggle', 'Click', 'uds-001'),
  udsComponentPencil: createEvent('UDS Component', 'Pencil', 'uds-002'),
  creditTierInput: createEvent('Credit Rating Dropdown', 'Select', 'uds-003'),
  termInput: createEvent('Term Length Dropdown', 'Select', 'uds-004'),
  tradeInInput: createEvent('Estimate Trade-in Value Field', 'Fill', 'uds-005'),
  amountOwedInput: createEvent('Amount Owed Field', 'Fill', 'uds-006'),
  downPaymentInput: createEvent('Down Payment Field', 'Fill', 'uds-007'),
  taxesAndFee: createEvent('Get Taxes and Fees Link', 'Click', 'uds-008'),
  tradeInLink: createEvent('Get Trade-in Value Link', 'Click', 'uds-009'),
  offerBreakdown: createEvent('Offer Breakdown Accordion', 'Click', 'uds-010'),
  udsComponentView: createEvent('UDS Component', 'View', 'uds-011'),
  udsComponetLoad: createEvent('UDS Component', 'Impression', 'uds-012'),
  udsComponentInitialClick: createEvent('UDS Component', 'Initial Click', 'uds-013'),
  continueDealSecondary: createEvent('Continue Deal Secondary Button', 'Click', 'uds-014'),
  continueDealPrimary: createEvent('Continue Deal Primary Button', 'Click', 'uds-015'),
  applyForFinancing: createEvent('Apply For Financing Link', 'Click', 'uds-016'),
  offerPriceInput: createEvent('Offer Price Field', 'Fill', 'uds-017')
};
export default {
  applicationData,
  nativeDealEventValues
};